export default __webpack_public_path__ + "static/Vision-redesign-f65f310444a52372b5d3ad4841507872.png";